import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaDove } from 'react-icons/fa';
import '../../../assets/css/customer/home/SmartPlanning.css';

const SmartPlanning = () => {
  const navigate = useNavigate();

  // ── NEW: loading state for Learn More button (same pattern as CustomerDashboard) ──
  const [navLoading, setNavLoading] = useState(false);

  const handleLearnMore = () => {
    setNavLoading(true);
    setTimeout(() => {
      navigate('/about');
      setNavLoading(false);
    }, 600);
  };

  return (
    <section className="about-section">
      <Container>
        <Row className="align-items-center">
          {/* Left Side - Content */}
          <Col lg={6} md={12} className="about-content-col">
            <div className="about-content">
              {/* Small Heading */}
              <h3 className="about-subtitle">About Bridely</h3>

              {/* Main Heading */}
              <h1 className="about-heading">
                Smart Planning for Your  Perfect<br />
                Wedding
              </h1>

              {/* Description */}
              <p className="about-description">
                Elegant planning for a truly unforgettable wedding.
              </p>

              {/* Learn More Button */}
              <button className="btn-learn-more" onClick={handleLearnMore} disabled={navLoading}>
                {navLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                    Loading...
                  </>
                ) : (
                  'Learn More'
                )}
              </button>

              {/* Decorative Dove Icon */}
              <div className="decorative-dove">
                <FaDove />
              </div>
            </div>
          </Col>

          {/* Right Side - Images Grid */}
          <Col lg={6} md={12} className="about-images-col">
            <div className="images-grid">
              {/* Large Image - Top Right */}
              <div className="image-box image-large">
                <img 
                  src="https://i.pinimg.com/736x/59/a2/62/59a262c973a1f94aaf4073157a59cb24.jpg" 
                  alt="Happy Couple" 
                  className="grid-image"
                />
                <div className="image-overlay">
                  <span className="overlay-text">Better Together</span>
                </div>
              </div>

              {/* Medium Image - Bottom Left */}
              <div className="image-box image-medium">
                <img 
                  src="https://i.pinimg.com/736x/4e/44/38/4e4438d716edc5ee3f403796027d6602.jpg" 
                  alt="Wedding Bouquet" 
                  className="grid-image"
                />
              </div>

              {/* Small Image - Bottom Right */}
              <div className="image-box image-small">
                <img 
                  src="https://i.pinimg.com/736x/ce/c7/19/cec719238068247e586e5d87b1ae35e4.jpg" 
                  alt="Wedding Rings" 
                  className="grid-image"
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SmartPlanning;